import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Title } from '@/components/Typography';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

export function Success() {
	return (
		<Row justify="center" gutter={[0, 10]}>
			<Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
				<CheckCircleOutlined className="bounce-in-up" style={{ fontSize: 80, color: DEFAULT_RISK_RPN_COLOR }} />
			</Col>
			<Col span={24} style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
				<Title style={{ color: DEFAULT_RISK_RPN_COLOR, whiteSpace: 'nowrap' }} className="fade-in" level={4}>
					{I18n.get('Action plan generated')}
				</Title>
			</Col>
		</Row>
	);
}
